import QueryArguments from './QueryArguments';
export default QueryArguments;